module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/media/quantum-phone-video-old.c189d272.mp4";